import { DSSpacer, DSText } from '@zoe/ds-web'
import styled from 'styled-components'

import { DSLinkText } from '@/components/ds/LinkText/LinkText'

import { trackFooterClick } from './Footer'

const StyledMenuContainer = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    transition: transform 0.3s ease-in-out;
    max-width: 200px;
    &:hover {
      transform: translateY(-2px);
    }
  }
`

export const FooterCompanyMenu: React.FC = () => {
  return (
    <StyledMenuContainer>
      <DSText as="h5" variant="fluid-label-100" weight="semiBold" color="primary-inverse">
        Company
      </DSText>
      <DSSpacer size={16} direction="vertical" />
      <ul>
        <li>
          <DSLinkText href="/about-us" onPress={() => trackFooterClick('About us')}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              About us
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
        <li>
          <DSLinkText href="https://jobs.ashbyhq.com/zoe" onPress={() => trackFooterClick('Careers')}>
            <DSText as="span" weight="light" variant="fluid-label-100" color="primary-inverse">
              Careers
            </DSText>
          </DSLinkText>
          <DSSpacer size={12} direction="vertical" />
        </li>
      </ul>
    </StyledMenuContainer>
  )
}
